const NavActionTypes = {
    SET_PLAYER_OPEN: "SET_PLAYER_OPEN",
    SET_PLAYER_SONG_DATA: "SET_PLAYER_SONG_DATA",
    SET_PLAYER_SONG_IDS: "SET_PLAYER_SONG_IDS",
    SET_CURRENT_INTERVAL: "SET_CURRENT_INTERVAL",
    SET_CURRENT_SONG_INDEX: "SET_CURRENT_SONG_INDEX",
  };
  
  export default NavActionTypes;
  